import { CompoundCarEndpoint } from "@module/_core/infras/config/endpointUrl/compoundCar";

export class AuthEndpoint extends CompoundCarEndpoint {
    static verifyRecaptcha = () => `${CompoundCarEndpoint.base}/v1/auth/web/login`;
    static verifyOTP = () => `${CompoundCarEndpoint.base}/v1/auth/otp/verification`;

    static getUserInfo = () => `${CompoundCarEndpoint.base}/v1/users/me`;
    static refreshToken = () => `${CompoundCarEndpoint.base}/v1/auth/refresh-token`;
}
